/* eslint-disable @typescript-eslint/no-explicit-any */
import { CommonModule } from "@angular/common";
import { Component, effect, input, output } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { TranslateModule } from "@ngx-translate/core";
import { PlaceholderReplacePipe } from "src/app/shared/pipes/placeholder-replace/placeholder-replace.pipe";

@Component({
  selector: "app-common-alert-modal",
  templateUrl: "./common-alert-modal.component.html",
  styleUrls: ["./common-alert-modal.component.scss"],
  imports: [TranslateModule, PlaceholderReplacePipe, CommonModule, FormsModule],
  standalone: true,
})
export class CommonAlertModalComponent {
  readonly title = input<string>("");
  readonly message = input<string>("");
  readonly cancelBtnTitle = input<string>("");
  readonly actionBtnTitle = input<string>("");
  readonly isModalOpen = input<boolean>(false);
  readonly actionType = input<string>("");
  readonly placeholderObject = input<any>(undefined);
  readonly hideSecondaryBtn = input<string>("");
  readonly isModalResponseClicked = output<any>();

  translationData: any;
  showCheckBox: boolean = false;
  isChecked: boolean = true;

  constructor() {
    effect(() => {
      if (this.actionType() === "FLORA_FAUNA_CONFIRMATION") {
        this.showCheckBox = true;
      }
    });
  }

  onCancel() {
    this.isModalResponseClicked.emit({ action: false });
  }

  onAction() {
    this.isModalResponseClicked.emit({
      action: true,
      actionType: this.actionType(),
      checkBoxValue:
        this.actionType() === "FLORA_FAUNA_CONFIRMATION" ? this.isChecked : false,
    });
  }
}
